import React from "react";
import ReactDOM from "react-dom/client";

// Redux
import {Provider} from "react-redux";

// Store
import Store from "./store";

import RootComponent from "./root";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

Store.dispatch({type: "STARTUP"});

root.render(
	<React.Fragment>
		<Provider store={Store}>
			<RootComponent/>
		</Provider>
	</React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
